import { graphql } from '@client/graphql/types';
import { useMutation } from '@apollo/client';

export const MUTATION = graphql(`
  mutation GenerateMultipleQRCodes($tableIds: [ID!]!) {
    generateMultipleQRCodes(tableIds: $tableIds) {
      qrCode
      tableId
    }
  }
`);

export function useGenerateMultipleQRCodes() {
  return useMutation(MUTATION, {});
}
